// extracted by mini-css-extract-plugin
module.exports = {"wantList":"WantList_wantList__3HRgu","setContainer":"WantList_setContainer__RO_ur"};